import { map } from "lodash";
import { Moment } from "moment";
import PosicaoAtivo, { IPosicaoAtivoJson } from "./posicaoAtivo";

export default class Posicao implements IPosicao {
  public data!: Moment;
  public posicoes!: PosicaoAtivo[];

  constructor(param: IPosicao) {
    Object.assign(this, param);
  }
  toJSON(): IPosicaoJson {
    return {
      ...this,
      data: this.data.format(),
      posicoes: map(this.posicoes, (p) => p.toJSON()),
    };
  }
}

export interface IPosicaoJson extends Omit<IPosicao, "data" | "posicoes"> {
  data: string;
  posicoes: IPosicaoAtivoJson[];
}

interface IPosicao {
  data: Moment;
  posicoes: PosicaoAtivo[];
}
